import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { colors } from 'gatsby-plugin-theme-ui/colors';

const defaultExitMenuLineAnimation = {
  transformOrigin: 'right center',
  rotate: '0deg'
};

export const topMenuLineAnimation = {
  initial: {
    transformOrigin: 'right center'
  },
  animate: {
    transformOrigin: 'right center',
    rotate: '-31deg'
  },
  exit: {
    ...defaultExitMenuLineAnimation,
    transition: {
      delay: 0.2
    }
  }
};

export const bottomMenuLineAnimation = {
  initial: {
    transformOrigin: 'right center'
  },
  animate: {
    transformOrigin: 'right center',
    rotate: '31deg'
  },
  exit: {
    ...defaultExitMenuLineAnimation,
    transition: {
      delay: 0.2
    }
  }
};

export const textMenuAnimation = {
  intital: {
    opacity: 1
  },
  animate: {
    opacity: 0
  },
  exit: {
    opacity: 1,
    transition: {
      delay: 0.2
    }
  }
};

export const onScrollNavigationBarAnimation = () => {
  // Hide scroll animation
  const showAnimation = gsap
    .from('.navigation-bar-wrapper', {
      yPercent: -100,
      paused: true,
      duration: 0.2
    })
    .progress(1);
  ScrollTrigger.create({
    start: '120px top',
    onUpdate: (self) => {
      self.direction === -1 ? showAnimation.play() : showAnimation.reverse();
    }
  });

  // collor change animation
  const onScrollAnimation = () => {
    const navigationBar = document.querySelector('.navigation-bar-wrapper');
    const mdlLogo = document.querySelector('.navigation-bar__mdl-logo');
    const navigationMenuButton = document.querySelector(
      '.navigation__menu-button'
    );
    const navigationMenuLines = [
      ...document.querySelectorAll('.navigation__menu-line')
    ];

    // The language switch link cannot accept className, it will replace the active className so we need to target the parent
    const langSwitchLinks = [
      ...document.querySelector('.navigation__language-switch').children
    ];

    // Navigation links also cannot accept className
    const navigationLinks = [
      ...document.querySelector('.navigation__nav-links').children
    ];

    // Navigation bar link underline
    const navigationLinkUnderline = [
      ...document.querySelectorAll('.navigation-bar__link_underline')
    ];

    // the delay 0.2s is related to time required by hide on scroll animation to finish
    const defaultTransition = 'all 0.5s ease 0.2s';
    navigationBar.style.transition = 'background-color 0.5s ease 0.2s';
    mdlLogo.style.transition = defaultTransition;
    navigationMenuButton.style.transition = defaultTransition;
    navigationMenuLines.forEach((line) => {
      line.style.transition = defaultTransition;
    });
    langSwitchLinks.forEach((link) => {
      link.querySelector('span').style.transition = defaultTransition;
    });
    navigationLinks.forEach((navlink) => {
      navlink.style.transition = defaultTransition;
    });

    if (
      document.body.scrollTop > 250 ||
      document.documentElement.scrollTop > 250
    ) {
      navigationBar.style.backgroundColor = colors.noise.onBackground;
      mdlLogo.style.color = colors.black;
      navigationMenuButton.style.color = colors.black;
      navigationMenuLines.forEach((line) => {
        line.style.backgroundColor = colors.black;
      });
      langSwitchLinks.forEach((link) => {
        link.querySelector('span').style.color = colors.black;
      });
      navigationLinks.forEach((navlink) => {
        navlink.style.color = colors.black;
      });
      navigationLinkUnderline.forEach((underline) => {
        underline.style.backgroundColor = colors.secondary;
      });
    } else {
      navigationBar.style.backgroundColor = null;
      mdlLogo.style.color = null;
      navigationMenuButton.style.color = null;
      navigationMenuLines.forEach((line) => {
        line.style.backgroundColor = null;
      });
      langSwitchLinks.forEach((link) => {
        link.querySelector('span').style.color = null;
      });
      navigationLinks.forEach((navlink) => {
        navlink.style.color = null;
      });
      navigationLinkUnderline.forEach((underline) => {
        underline.style.backgroundColor = null;
      });
    }
  };
  if (window) {
    window.addEventListener('scroll', onScrollAnimation);
    return () => {
      window.removeEventListener('scroll', onScrollAnimation);
    };
  }
};
